// define global variables for ESLint
/* global ajax_object, YT */
const Holder = require("holderjs");

Number.prototype.normalize = function (min, max) {
    return (this - min) / (max - min);
}
Number.prototype.clamp = function (min, max) {
    return Math.min(Math.max(this, min), max);
};
Number.prototype.roundStep = function (increment, offset) {
    offset = offset || 0;
    return Math.round((this - offset) / increment) * increment + offset;
}

/**
 * Replace IMG-tag with the actual SVG
 *
 * New SVG keeps the classes and adds 'replaced-svg', keeps height and width.
 * Triggers 'img.replaced' on the image
 *
 * @param string selector The jQuery selector
 * @param array classes Replacing stX classes with a different name
 */
$.fn.replaceSVG = function (classes) {
    $(this).each(function () {
        let $img = $(this);
        let imgID = $img.attr('id'),
            imgClass = $img.attr('class'),
            imgURL = $img.attr('src'),
            stClass = $img.attr('data-svg-class');

        $.get(imgURL, function (data) {
            let $svg = $(data).find('svg');

            $svg.attr('id', imgID || '');

            $svg = $svg.attr('class', imgClass + ' replaced-svg');

            $svg.removeAttr('xmlns:a')
                .removeClass('svg')
                .attr('width', $img.attr('width'))
                .attr('height', $img.attr('height'));

            if ($svg.html())
                $svg.html($svg.html().replace(/st0/g, stClass + '-0'));

            $img.trigger('img.replaced', [$svg])
                .replaceWith($svg);
        }, 'xml');
    });
    return $(this);
};
$.fn.swapPlaces = function ($before, $after, condition) {
    if (condition && $(this).parent() != $after) {
        $(this).detach().appendTo($after)
    } else if ($(this).parent() != $before) {
        $(this).detach().appendTo($before);
    }
}

/**
 * Scroll Animation
 *
 * Shows an animation when scrolled to the element, depending on the parents offset.
 */
$.fn.scrollAnimation = function (options) {
    let $elementse = $(this);
    $elementse.each(function (i, e) {
        $(this).on('scroll.animation', function (e, action) {
            e.stopPropagation();

            // get data
            let data = $(this).data('scroll-animation');
            data = typeof data != 'object' ? $.fn.scrollAnimation[data] : data;
            let settings = $.extend({}, $.fn.scrollAnimation.defaults, data, options);

            // prepare easings
            let easingArr = settings.easing.split(' ');
            let easingOutArr = settings.easingOut.split(' ');

            // calculate offsets
            let offsetHeader = $('header.header-fixed').height();
            offsetHeader += $('#wpadminbar').height();

            // calculate scroll position
            let bottom = $(this).parent().offset().top - $(window).scrollTop() + $(this).height() - offsetHeader,
                top = $(this).parent().offset().top - $(window).scrollTop() - $(window).height();

            // set action
            let topDownIn = (top < -settings.offset && action == 'down'),
                bottomUpIn = (bottom < -settings.offset && action == 'up');
            let topDownOut = (bottom < -settings.offset && action == 'down'),
                bottomUpOut = (top > -settings.offset && action == 'up');

            if (action == 'in') {
                $(this).removeClass('animated ' + settings.easing).css({
                    animationDelay: '0s',
                });
            } else if (action == 'out') {
                $(this).removeClass('animated ' + settings.easingOut);
            }

            //setTimeout(function() {
            if (topDownIn || bottomUpIn || action == 'in') {
                let neweasing = settings.easing;
                if (easingArr[1]) {
                    neweasing = bottomUpIn || $(this).hasClass(easingArr[1]) ? easingArr[1] : easingArr[0];
                }
                $(this).removeClass(settings.easingOut).css({
                    animationDelay: settings.delay
                }).addClass('animated ' + neweasing);
            }
            if (settings.easingOut) {
                if (topDownOut || bottomUpOut || action == 'out') {
                    let neweasing = settings.easingOut;
                    if (easingOutArr[1]) {
                        neweasing = bottomUpOut ? easingOutArr[1] : easingOutArr[0];
                    }
                    $(this).removeClass(settings.easing).css({
                        animationDelay: settings.delay
                    }).addClass('animated ' + neweasing);
                }
            }
        });
    });

    // animate on scroll
    let previousScroll = $(window).scrollTop();
    $(window).on('scroll touchmove touchstart touchend touchenter touchleave touchcancel', function () {
        let currentScroll = $(window).scrollTop();
        let scrollingDown = currentScroll >= previousScroll;

        $elementse.each(function (i, e) {
            $(this).trigger('scroll.animation', [scrollingDown ? 'down' : 'up']);
        });

        previousScroll = currentScroll;
    });
    return $(this);
};

$.fn.scrollAnimation.defaults = {
    easing: 'fadeIn',
    offset: 32,
    easingOut: '',
    delay: 0,
    force: false,
};

$.fn.scrollAnimation.fadeComplete = {
    easing: 'fadeInUpSmall fadeInDownSmall',
    easingOut: 'fadeOutUpSmall fadeOutDownSmall',
};


$.fn.swap = function ($element, condition) {
    $(this).replaceWith($element.clone());
    $element.replaceWith($(this).clone());
    return $(this);
};

// most useful function hehexd
$.fn.exists = function () {
    return this.length > 0;
};


$.fn.overlay = function () {
    $(this).each(function (i, e) {

        $(this).click(function (e) {
            let $content = $($(this).data('overlay')).clone();
            $('#overlay').html($content).fadeIn();
            $('body').addClass('overlay-active');
            $content.find('.scroll-animation').trigger('scroll.animation', ['in']);
            $content.find('input').get(0).focus();

            $content.find('.overlay-close').click(function (e) {
                $('#overlay').fadeOut();
                $('body').removeClass('overlay-active');
            });
        });
    });
    return $(this);
};
$(document).on('keygroup', function (e, key) {
    if (key.group == 'esc') {
        $('#overlay').fadeOut();
        $('body').removeClass('overlay-active');
    }
});


$.fn.formSubmit = function (form) {
    $(this).each(function (i, e) {
        $(this).click(function (e) {
            $(this).parents('form').submit();
        });
    });
    return $(this);
};


$.fn.accordion = function (options) {
    $(this).each(function (i, e) {
        $(this).find('.ac-item .ac-content').slideUp(0);
        $('.ac-title').click(function (e) {

            let $parent = $(this).parents('.ac-items');

            let ain = $parent.find('.ac-item.active').index();
            let cin = $(this).parent().index();

            let animate = (ain != -1 && ain < cin);

            $parent.find('.ac-item.active .ac-content').stop().slideUp({
                complete: function () {
                    if (animate) {
                        $('html,body').animate({scrollTop: $(this).parent().offset().top - 25});
                    }
                }
            });
            $parent.find('.ac-item').not($(this).parent()).removeClass('active');
            $parent.find('.ac-title').not($(this)).removeClass('active');

            $(this).toggleClass('active').parent().toggleClass('active');
            $(this).next().stop().slideToggle();

        });
    });
};
$.fn.accordion.defaults = {
    multiple: false,
    time: 400,
    scroll: true,
};

$.fn.wpAjax = function (data, action) {
    action = action || function (data) {
    };
    $.ajax({
        type: 'post',
        url: ajax_object.ajax_url,
        data: data,
        success: action
    });
};
$.fn.infiniteScroll = function (options) {
    let $elements = $(this);
    let loading = false;
    $elements.on('infinite.scroll', function (e, force) {
        let data = $(this).data('infinite-scroll');
        data = typeof data != 'object' ? $.fn.infiniteScroll[data] : data;
        let settings = $.extend({}, $.fn.infiniteScroll.defaults, data, options);

        let scroll = $(window).scrollTop();
        let offset = $(this).offset().top + $(this).height() - $(window).height();


        if (!loading && (scroll > offset || force)) {
            loading = true;
            $.fn.wpAjax(settings, function (response) {
                if (response) {
                    let $response = $($.parseHTML(response));
                    $(this).prepend($response);
                    setTimeout(function () {
                        wpInit($response);
                    }, 0);

                    let data = $(this).data('infinite-scroll');
                    data.offset += data.count;
                    $(this).data('infinite-scroll', data);

                    loading = false;
                } else {
                    $(this).find('.infinite-scroll-end').fadeIn();
                }
            }.bind(this));
        }
    });
    $(window).scroll(function () {
        $elements.each(function (i, e) {
            $(this).trigger('infinite.scroll');
        });
    });
    $(window).scroll();
};
$.fn.infiniteScroll.defaults = {
    action: '',
}


$.fn.imgCover = function () {
    let $elements = $(this);
    $elements.on('img.cover', function (e) {
        let w = $(this).get(0).naturalWidth / $(this).parent().outerWidth();
        let h = $(this).get(0).naturalHeight / $(this).parent().outerHeight();
        if (h < w) {
            $(this).width('auto');
            $(this).height($(this).parent().outerHeight() + 2);
        } else {
            $(this).height('auto');
            $(this).width($(this).parent().outerWidth() + 2);
        }
    });
    $(window).resize(function () {
        setTimeout(function (e) {
            $elements.each(function (i, e) {
                $(this).trigger('img.cover');
            });
        }, 0);
    });
    setTimeout(function (e) {
        $elements.trigger('img.cover');
    }, 0);
};

$.fn.itemFilter = function (options) {
    let $elements = $(this);
    $elements.each(function (i, e) {
        let data = $(this).data('filter');
        data = typeof data != 'object' ? $.fn.itemFilter[data] : data;
        let settings = $.extend({}, $.fn.itemFilter.defaults, data, options);

        // apply event
        $(this).on('apply.ns.filter', function (e) {
            let filter = {};
            $(this).find('.filter-active').each(function (i, e) {
                let ap = $(this).data('filter-apply');
                $.extend(filter, ap);
            });

            let $items = $(settings.target).find('.filter-item');
            if (!$.isEmptyObject(filter)) {
                $items.each(function (i, e) {

                    let data = $(this).data('filter-item');
                    let extended = $.extend({}, data, filter);


                    if (JSON.stringify(data) == JSON.stringify(extended)) {
                        $(this).addClass('filter-item-active').stop().fadeIn(400);
                    } else {
                        $(this).removeClass('filter-item-active').stop().fadeOut(400);
                    }
                });
            } else {
                let $def = $('.filter-item-default');
                $items.not($def).removeClass('filter-item-active').stop().fadeOut(400);
                $def.addClass('filter-item-active').stop().fadeIn(400);
            }
            $(this).trigger('change.ns.filter');
        });

        // click on apply
        $(this).find('.filter-apply').click(function (e) {
            let $parent = $(this).parents('.filter');
            let groupId = $(this).data('filter-group');
            let $group = $parent.find('[data-filter-group="' + groupId + '"]');

            $group.not($(this)).removeClass('filter-active');
            $(this).toggleClass('filter-active');

            $parent.trigger('apply.ns.filter');
        });

        // first init
        $(this).trigger('apply.ns.filter');
    });
}

$.fn.itemFilter.defaults = {
    target: 'body',
};


$.fn.autoHeight = function (options) {

}

/**
 * Keydown
 *
 * Triggers keygroup on specific groups of keys, such as "up" or "down"
 */
$(document).keydown(function (e) {
    let keys = {
        up: [38, 33, 36],
        down: [40, 34, 35],
        left: [37],
        esc: [27],
    };
    for (let key in keys) {
        for (let i = 0; i < keys[key].length; i++) {
            if (e.keyCode == keys[key][i]) {
                $(document).trigger('keygroup', [{group: key, code: e.keyCode}]);
                break;
            }
        }
    }
});


/**
 * Holder
 */
Holder.addTheme('nosun', {
    bg: '#f2f2f2',
    fg: '#00A9A0',
    size: 12,
    font: 'Monaco',
    fontweight: 'normal',
});

$.fn.findSelf = function (selector) {
    let result = this.find(selector);
    return (this.is(selector)) ? result.add(this) : result;
};

if ($.fn.owlCarousel && !$.fn.owlCarousel.defaults) $.fn.owlCarousel.defaults = {};

function wpInit($parent) {
    $parent = $parent || $(document);

    $parent.each(function () {
        $(this).findSelf('.player').each(function () {
            let id = $(this).attr('data-id');
            new YT.Player(id, {
                height: '100%',
                width: '100%',
                playerVars: {
                    rel: 0,
                    showinfo: 0,
                },
                videoId: id,
                events: {
                    'onStateChange': function (event) {
                        if (event.data == YT.PlayerState.PLAYING) {
                            $('#nk-' + id).addClass('playing');
                        } else {
                            $('#nk-' + id).removeClass('playing');
                        }
                    }
                }
            });
        });
    });

    $parent.each(function (i, e) {
        $(this).findSelf('.filter').itemFilter();

        $(this).findSelf('.owl-carousel').each(function (e) {
            let data = $(this).data('owl-carousel');
            data = typeof data != 'object' ? $.fn.owlCarousel[data] : data;
            data = $.extend({}, $.fn.owlCarousel.defaults, data);
            if ($(this).children().length == 1) {
                data = $.extend({}, data, {
                    mouseDrag: false,
                    touchDrag: false,
                    pullDrag: false,
                    freeDrag: false,
                });
            }
            $(this).data('owl-carousel');
            $(this).owlCarousel(data).on('changed.owl.carousel', function (e) {
                let $items = $(this).find(".owl-item");
                $items.removeClass('active-true');

                let cofs = Math.floor(e.item.count / 2) + 1;
                if ($(this).attr('data-owl-carousel-link')) console.log($(this).attr('data-owl-carousel-link'), e.item.index % e.item.count, e.item.index - cofs);

                let $current = $items.eq(e.item.index).addClass('active-true');
                $current.find('.scroll-animation').trigger('scroll.animation', ['in']);

                let $link = $($(this).attr('data-owl-carousel-link'));

                cofs = (e.item.count <= 3 ? e.item.index % e.item.count : e.item.index - cofs);
                $link.trigger('to.owl.carousel', [cofs]);
            });

            $(this).find('.owl-prev').attr('role', 'button').attr('title', 'Previous');
            $(this).find('.owl-next').attr('role', 'button').attr('title', 'Next');
            $('.owl-prev, .owl-next').attr('tabindex', '0');
        });

        $(this).findSelf('.ac-items').accordion();
        $(this).findSelf('.overlay').overlay();
        $(this).findSelf('.form-submit').formSubmit();
        $(this).findSelf('.svg').replaceSVG();
        $(this).findSelf('.scroll-animation').scrollAnimation();

        $(window).on('load', function (e) {
        }.bind(this));


        if ($.fn.magnificPopup) {
            $(this).findSelf('.popup-youtube').magnificPopup({
                type: 'iframe',
                mainClass: 'animated fadeIn',
                removalDelay: 160,
                preloader: false,
                fixedContentPos: false,
                iframe: {
                    patterns: {
                        youtube_short: {
                            index: 'youtu.be/',
                            id: 'youtu.be/',
                            src: '//www.youtube.com/embed/%id%?autoplay=1',
                        }
                    }
                }
            });
        }

        $(this).findSelf('[href="#"]').click(function (e) {
            e.preventDefault();
        });


        $(window).scroll();
        $(window).resize();

        Holder.run();
    });
}

$(document).ready(function () {

    $('.screen-reader-shortcut').attr('tabindex', 0);


    $(this).find('.panel-grid').each(function (i, e) {
        if ($(this).children().length > 1) {
            let cc = $('body').hasClass('single-post') ? 'container-small' : '';
            if (!$('body').hasClass('single-post')) {
                $(this).addClass('container');
            }
            $(this).addClass('container2').wrap('<div class="p-wrap container ' + cc + '"><div class="row"><div class="col"></div></div></div>');
        }
    });

    $(window).scroll(function () {
        let scroll = $(window).scrollTop() > 0;
        if (scroll) {
            $(window).trigger('scroll.top');
        } else {
            $(window).trigger('scroll.mid');
        }
        $('body').toggleClass('scroll', scroll);
    });

    $(window).resize(function (e) {
        let width = $(window).width();
        $('body').toggleClass('lg', width < 992);
        $('body').toggleClass('md', width < 768);
        $('body').toggleClass('sm', width < 575);
        //trigger on change?

        let footer = !$('footer').hasClass('footer-fixed') ? $('footer').height() : 0;
        $('main').css({
            minHeight: $(window).height() - footer,
        });
        $('.header-spacing').height($('header').outerHeight());
        $('.footer-spacing').height($('footer').outerHeight());

        setTimeout(function () {
            $('.scrollbar-hide-y').each(function (e) {
                let width = this.offsetWidth - this.clientWidth;
                $(this).css({
                    marginRight: -width,
                });
            });
            $('.scrollbar-hide-x, .content tbody').each(function (e) {
                let width = this.offsetHeight - this.clientHeight;
                $(this).css({
                    top: width
                });
            });
        }, 0);
    });

    // init
    setTimeout(function () {
        wpInit();
        setTimeout(function () {
            $(window).scroll();
            $(window).resize();
            $(document).trigger('ready.ns');
        }, 0);
        $(this).findSelf('.img-cover').imgCover();
    }.bind(this), 0);

    $('.svg, svg').each(function (i, e) {
        $(this).width($(this).width());
    })
});
